import { Button as MuiButton, styled } from "@mui/material";
import { NavLink } from "react-router";
import type { NavigationLinkStylesProps } from "../types";
import { AccountMenuItem } from "./AccountMenuItem";
import { AccountMenuLinkProps } from "./AccountMenuLink.props";

const AccountMenuLinkButton = styled(({ children, ...props }: NavigationLinkStylesProps) => (
  <MuiButton component={NavLink} end {...props} variant="text" disableRipple>
    {children}
  </MuiButton>
))(
  ({
    theme: {
      breakpoints,
      typography: { button }
    }
  }) => `
    font-size: ${button.mobile.fontSize};
    line-height: ${button.mobile.lineHeight};
    font-weight: ${button.mobile.fontWeight};
    text-transform: uppercase;

    ${breakpoints.up("md")} {
      font-size: ${button.tablet.fontSize};
      line-height: ${button.tablet.lineHeight};
      font-weight: ${button.tablet.fontWeight};
    }

    ${breakpoints.up("lg")} {
      font-size: ${button.desktop.fontSize};
      line-height: ${button.desktop.lineHeight};
      font-weight: ${button.desktop.fontWeight};
    }

    &:hover {
      background: none;
    }
  `
);

export const AccountMenuLink = ({
  active,
  children,
  icon,
  iconPosition,
  onClick,
  to,
  ...props
}: AccountMenuLinkProps) => (
  <AccountMenuItem active={active} {...props}>
    <AccountMenuLinkButton
      disabled={active}
      endIcon={iconPosition === "end" ? icon : undefined}
      onClick={onClick}
      startIcon={iconPosition === "start" ? icon : undefined}
      to={to}
    >
      {children}
    </AccountMenuLinkButton>
  </AccountMenuItem>
);
